// extracted by mini-css-extract-plugin
export default {"formContainer":"style_formContainer__G+bJY","spinner":"style_spinner__xtmgu","form":"style_form__NoTeo"};